import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.2249 7.1582L10.3999 10.9749L6.5749 7.1582L5.3999 8.3332L10.3999 13.3332L15.3999 8.3332L14.2249 7.1582Z", fill: "inherit" }));
export default SvgChevron;
